import { ERROR_CODES, getErrorCodeFromStatus, type ErrorCode } from "./codes";

/**
 * Custom error class that includes an error code from the API.
 * Used for translating error messages on the frontend.
 */
export class ApiError extends Error {
  constructor(
    public readonly code: ErrorCode | string,
    message: string
  ) {
    super(message);
    this.name = "ApiError";
  }

  /**
   * Create an ApiError from an API error response
   */
  static fromResponse(
    error: { code?: string; message?: string } | undefined,
    fallbackMessage: string
  ): ApiError {
    const code = error?.code || ERROR_CODES.UNKNOWN;
    const message = error?.message || fallbackMessage;
    return new ApiError(code, message);
  }

  /**
   * Create an ApiError from HTTP status code
   */
  static fromStatus(status: number, message?: string): ApiError {
    const code = getErrorCodeFromStatus(status);
    return new ApiError(code, message || `HTTP Error ${status}`);
  }
}
